/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.UserFileds } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && (currentUser as any).access === 'admin',
  };
}
